import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../../../components/buttons/buttons.component'
import {
	CPFInput,
	EmailInput,
	TextInput,
	RGInput
} from '../../../components/form-components/inputs.component'
import Yup from './../../../helpers/custom-yup'
import { connect } from 'react-redux'
import { Creators as AuthenticationCreators } from '../../../ducks/authentication/authentication'

const schema = Yup.object().shape({
	name: Yup.string()
		.name()
		.required('Informe o nome completo'),
	cpf: Yup.string()
		.cpf()
		.required('Informe o CPF'),
	rg: Yup.string()
		.rg()
		.required('Informe o RG'),
	email: Yup.string()
		.required('Informe o e-mail')
		.email('E-mail inválido'),
	emailConfirmation: Yup.string()
		.equalTo(Yup.ref('email'), 'Os e-mails digitados não conferem')
		.required('Informe a confirmação do e-mail')
})

const StyledInputContainer = styled.div`
	margin-top: 4rem;
`

const StyledInputWithInformationContainer = styled.div`
	margin-top: 4rem;
	input {
		width: 300px;
		@media (max-width: 600px) {
			width: 100%;
		}
	}
	.static-information {
		position: absolute;
		left: 320px;
		bottom: 0;
		margin: 0;
		padding: 0;
	}
	@media (max-width: 600px) {
		.static-information {
			display: none;
		}
	}
	@media (max-width: 320px) {
		input {
			width: 100%;
		}
	}
`

const StyledButtonContainer = styled.div`
	margin-top: 5rem;
	display: flex;
	justify-content: flex-end;
`

export default class PersonalForm extends Component {
	constructor(props) {
		super(props)
		this.nameRef = React.createRef()
		this.cpfRef = React.createRef()
		this.rgRef = React.createRef()
		this.emailRef = React.createRef()
		this.emailConfirmationRef = React.createRef()
	}

	onEnter = () => {
		setTimeout(() => {
			this.nameRef.current.focus()
		}, 0)
	}

	complementaryDataFocus = () => {
		document.getElementById('birthday').focus()
		window.scrollTo(0, 250)
	}


	render() {
		const { onSubmit, onClick } = this.props
		return (
			<Formik
				ref="form"
				initialValues={{
					name: '',
					cpf: '',
					rg: '',
					email: '',
					emailConfirmation: ''
				}}
				onSubmit={(values, actions) => {
					const name = values['name'] || ''
					actions.setFieldValue('name', name.trim().replace(/\s+/g, ' '))
					return onSubmit(values, actions)
				}}
				validationSchema={schema}
				render={props => (
					<Form noValidate>
						<TextInput
							elementRef={this.nameRef}
							id="name"
							label="Nome *"
							maxLength={128}
							autoFocus={true}
							{...props}
						/>
						<StyledInputWithInformationContainer>
							<CPFInput
								elementRef={this.cpfRef}
								id="cpf"
								label="CPF *"
								information={() => (
									<p className="static-information">
										Digite apenas números.
									</p>
								)}
								{...props}
							/>
						</StyledInputWithInformationContainer>
						<StyledInputWithInformationContainer>
							<RGInput
								maxLength={14}
								elementRef={this.rgRef}
								id="rg"
								label="RG *"
								information={() => (
									<p className="static-information">
										Para acumular pontos informe esse RG no momento da
										compra no site da Planalto.
									</p>
								)}
								{...props}
							/>
						</StyledInputWithInformationContainer>
						<StyledInputContainer>
							<EmailInput
								elementRef={this.emailRef}
								id="email"
								label="E-mail *"
								{...props}
							/>
						</StyledInputContainer>
						<StyledInputContainer>
							<EmailInput
								elementRef={this.emailConfirmationRef}
								id="emailConfirmation"
								label="Confirme o E-mail *"
								{...props}
							/>
						</StyledInputContainer>
						<StyledButtonContainer>
							<Button
								primary
								type="submit"
								onClick={() => {
									onClick && onClick(props.isValid)
									if (!props.isValid) {
										const id = Object.keys(props.errors)[0]
										const ref = this[`${id}Ref`]
										if (!ref || !ref.current) return
										ref.current.focus()
									} else {
										this.complementaryDataFocus()
									}
								}}>
								Avançar
							</Button>
						</StyledButtonContainer>
					</Form>
				)}
			/>
		)
	}
}

PersonalForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onClick: PropTypes.func
}